import React, { useEffect, useState, useRef, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
} from "@mui/material";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { useQuery, useMutation } from "@apollo/client";
import { ToWords } from "to-words";
//date picker
import moment from "moment";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Srcs
import "../../../Style/pagestyle.scss";
import {
  currencyFormat,
  currencyFormatRiel,
} from "../../../Function/DynamicFn";
import {
  GET_STUDENT_PAYMENT_BY_ID,
  ADD_STUDENT_PAYMENT,
  GET_NEXT_INV,
} from "../../../Schema/StudentPayment";
import { AuthContext } from "../../../Context/AuthContext";
import LogoSchool from "../../../Assets/goglobal-school.png";
import WingdingImage from "../../../Assets/tacteing.jpg";

const toWords = new ToWords({
  localeCode: "en-US",
  converterOptions: {
    currency: false,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: true,
  },
});

export default function PreviewPrintInvoice({
  open,
  handleClose,
  billToVal,
  vattin,
  paymentDate,
  paymentList,
  totalKHR,
  totalUSD,
  studentId,
  detailsData,
  classVal,
}) {
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);
  const [nextINVNumber, setNextINVNumber] = useState([]);

  // console.log("classVal::", classVal)

  const { refetch } = useQuery(GET_NEXT_INV, {
    onCompleted: ({ getNextInvoiceNumbering }) => {
      setNextINVNumber(getNextInvoiceNumbering);
    },
  });

  useEffect(() => {
    refetch();
  }, [open]);

  //================================ multation create payment ====================================
  const [addPayment] = useMutation(ADD_STUDENT_PAYMENT, {
    onCompleted: ({ addPayment }) => {
      setLoading(false);
      // console.log("addPayment::", addPayment);
      if (addPayment?.status === true) {
        setAlert(true, "success", addPayment?.message);
        handleClose();
      } else {
        setAlert(true, "error", addPayment?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const handleSubmit = () => {
    const paymentToSubmit = paymentList.map((item) => {
      return {
        fee: item?.feeId,
        amount: parseFloat(item?.amount),
        startDate: moment(item?.startDate).format("YYYY-MM-DD"),
        endDate: moment(item?.endDate).format("YYYY-MM-DD"),
        qty: parseInt(item?.qty),
        totalAmount: item?.totalAmount,
      };
    });
    // const mergedArray = priceToSubmit.concat(paymentToSubmit);
    // console.log("paymentToSubmit::", paymentToSubmit);
    addPayment({
      variables: {
        input: {
          billTo: billToVal?.id,
          paymentDate: moment(paymentDate).format("YYYY-MM-DD"),
          studentInfo: studentId,
          vattIn: vattin,
          payments: paymentToSubmit,
          totalUSD: totalUSD,
          totalKHR: totalKHR,
        },
      },
    });
  };

  // console.log("printData", printData);
  // print
  const componentRef = useRef();
  const reactToPrintContent = () => {
    handleSubmit();
    return componentRef.current;
  };

  const reactToPrintTrigger = () => {
    return (
      <Button
        sx={{
          width: "20%",
          padding: "6px",
          borderRadius: "10px",
          color: "white",
          backgroundColor: "#0f81c2 !important",
        }}
      >
        Save & Print
      </Button>
    );
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">View invoice</Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Box className="print-invoice-container">
          <Box sx={{ marginTop: "10px" }}>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction="row" justifyContent="left">
                  <Stack direction="column" sx={{ paddingLeft: "20px" }}>
                    <Stack direction="row" justifyContent="center">
                      <img
                        src={LogoSchool}
                        style={{ marginTop: "16px", width: "125px" }}
                      />
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{ fontSize: "14px", fontFamily: "KhmerOsMuol" }}
                    align="center"
                  >
                    ព្រះរាជាណាចក្រកម្ពុជា
                  </Typography>
                  <Typography
                    sx={{ fontSize: "14px", fontFamily: "GothicBoldRegular" }}
                    align="center"
                  >
                    Kingdom Of Cambodia
                  </Typography>
                  <Typography
                    sx={{ fontSize: "14px", fontFamily: "KhmerOsMuol" }}
                    align="center"
                  >
                    ជាតិ​ សាសនា ព្រះមហាក្សត្រ
                  </Typography>
                  <Typography
                    sx={{ fontSize: "14px", fontFamily: "GothicBoldRegular" }}
                    align="center"
                  >
                    Nation Religions King
                  </Typography>
                  <Stack direction="row" justifyContent="center">
                    <img
                      alt="Image"
                      src={WingdingImage}
                      className="print-invoice-tackteng"
                    />
                  </Stack>
                </Box>
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>

            <Box sx={{ marginTop: "20px" }}>
              <Grid container>
                <Grid item xs={4}>
                  <Stack direction="column">
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        ឈ្មោះសហគ្រាស :
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        ហ្គោ គ្លូបប៊ល ស្គូល
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        អាសយដ្ឋាន៖
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        ភូមិថ្មី សង្កាត់ស្វាយដង្គំ
                      </Typography>
                    </Stack>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      ក្រុងសៀមរាប ខេត្តសៀមរាប
                    </Typography>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        Tel:
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        076 777 1168 | 085 705 555
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        VATTIN:
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {vattin}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack direction="column">
                    <Typography
                      sx={{ fontFamily: "Bayon", fontSize: "14px" }}
                      align="center"
                    >
                      <u>វិក្កយបត្រ</u>
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Baloopaaji",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      align="center"
                    >
                      Invoice
                    </Typography>
                  </Stack>
                </Grid>

                <Grid item xs={4}>
                  <Stack direction="column">
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        N° :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {moment().format("YYYY") + nextINVNumber}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        Bill To :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {billToVal?.title}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        Payment Date :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {moment(paymentDate).format("DD-MMM-YYYY hh:mm a")}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ marginTop: "15px" }}>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ព័ត៌មានសិ្ស/Student Information
              </Typography>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
              <Grid container>
                <Grid item xs={6}>
                  <Stack direction="column" sx={{ marginTop: "4px" }}>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        ឈ្មោះជាភាសាខ្មែរ/Full Name :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {detailsData?.lastName + " " + detailsData?.firstName}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        អត្តលេខ/Khmer ID :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {detailsData?.student_id}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        ភេទ :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {detailsData?.gender}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        កម្រិត/Levels :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {classVal?.title?.title}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={6}>
                  <Stack direction="column" sx={{ marginTop: "4px" }}>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        ឈ្មោះឡាតាំង/Latin :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {detailsData?.englishName}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        ថ្ងៃខែឆ្នាំកំណើត/Date of Birth :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {moment(detailsData?.dob).format("DD-MMM-YYYY")}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        ពេលសិក្សា/Shift Time :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {classVal.shiftName}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Typography
                        sx={{
                          fontFamily: "Siemreap",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        លេខទូរស័ព្ទ/Tel :
                      </Typography>
                      <Typography
                        sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                      >
                        {detailsData?.mother?.tel +
                          " | " +
                          detailsData?.father?.tel}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ marginTop: "15px" }}>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ការបង់ថ្លៃ/Payment
              </Typography>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
          </Box>

          <table className="print-invoice-table1">
            <tr>
              <th style={{ width: "5%" }} align="left">
                ល.រ
              </th>
              <th style={{ width: "20%" }} align="left">
                បង់ថ្លៃ/Pay To
              </th>
              <th style={{ width: "20%" }} align="left">
                បរិយាយ/Desciption
              </th>
              <th style={{ width: "15%" }} align="left">
                ចាប់ទី/Start Date
              </th>
              <th style={{ width: "15%" }} align="left">
                រហូតដល់/End Date
              </th>
              <th style={{ width: "25%" }} align="right">
                សរុប/Total Amount
              </th>
            </tr>
            {paymentList?.map((row, index) => {
              // console.log("row::", row);
              return (
                <tr key={index}>
                  <td align="left">{index + 1}</td>
                  <td align="left">
                    {row?.feeName ? row?.feeName : "តម្លៃសិក្សា"}
                  </td>
                  {row?.qty < 12 ? (
                    <td align="left">
                      {row?.qty} {row?.qty === 1 ? "month" : "months"}
                    </td>
                  ) : (
                    <td align="left">{row?.qty} year</td>
                  )}
                  <td align="left">
                    {moment(row?.startDate).format("DD-MM-YYYY")}
                  </td>
                  <td align="left">
                    {moment(row?.endDate).format("DD-MM-YYYY")}
                  </td>
                  <td align="right">
                    {currencyFormat(parseFloat(row?.totalAmount))}
                  </td>
                </tr>
              );
            })}
          </table>
          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ padding: "4px" }}
            >
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                សរុប (ដុល្លារ)/Total Amount ($) :
              </Typography>
              <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}>
                $ {currencyFormat(parseFloat(totalUSD))}
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>
          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ padding: "4px" }}
            >
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                សរុប (រៀល)/Total Amount (Riels) :
              </Typography>
              <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}>
                {currencyFormatRiel(parseFloat(totalKHR))} ៛
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>
          <Box>
            <Stack direction="row" spacing={0.4} sx={{ padding: "4px" }}>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ចំនួនទឹកប្រាក់ជាអក្សរ (ដុល្លារ)/Amount In Letter ($) :
              </Typography>
              <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}>
                {toWords.convert(totalUSD ? parseFloat(totalUSD) : 0)} Dollar
                Only
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>
          <Box sx={{ marginTop: "50px" }}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <Box className="print-invoice-box-bottom">
                  <Typography
                    sx={{
                      fontFamily: "Bayon",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    ប្រាក់បង់រូចមិនអាចដក ផ្ទេរ និងរក្សាទុកបានទេ
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Siemreap",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    All processed payments will not be refunded, transfered, or
                    kept.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Stack
                  direction="column"
                  spacing={0.2}
                  sx={{ marginTop: "18px" }}
                >
                  <Divider sx={{ borderBottom: "1px solid #000" }} />
                  <Stack direction="row" spacing={0.2}>
                    <Typography sx={{ fontFamily: "Bayon", fontSize: "12px" }}>
                      អ្នកបង់ប្រាក់
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      (Payer)
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack
                  direction="column"
                  spacing={0.2}
                  sx={{ marginTop: "18px" }}
                >
                  <Divider sx={{ borderBottom: "1px solid #000" }} />
                  <Stack direction="row" spacing={0.2}>
                    <Typography sx={{ fontFamily: "Bayon", fontSize: "12px" }}>
                      បេឡាធិការ
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      (Cashier)
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* ============================================ code to print =============================================== */}

        <Box sx={{ display: "none" }}>
          <Box className="print-invoice-container" ref={componentRef}>
            <Box sx={{ marginTop: "10px" }}>
              <Grid container>
                <Grid item xs={4}>
                  <Stack direction="row" justifyContent="left">
                    <Stack direction="column" sx={{ paddingLeft: "20px" }}>
                      <Stack direction="row" justifyContent="center">
                        <img src={LogoSchool} className="print-invoice-logo" />
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Typography className="print-invoice-title-kh">
                      ព្រះរាជាណាចក្រកម្ពុជា
                    </Typography>
                    <Typography className="print-invoice-title-en">
                      Kingdom Of Cambodia
                    </Typography>
                    <Typography className="print-invoice-title-kh">
                      ជាតិ​ សាសនា ព្រះមហាក្សត្រ
                    </Typography>
                    <Typography className="print-invoice-title-en">
                      Nation Religions King
                    </Typography>
                    <Stack direction="row" justifyContent="center">
                      <img
                        alt="Image"
                        src={WingdingImage}
                        className="print-invoice-tackteng"
                      />
                    </Stack>
                  </Box>
                </Grid>
                <Grid item xs={4}></Grid>
              </Grid>

              <Box sx={{ marginTop: "20px" }}>
                <Grid container>
                  <Grid item xs={4}>
                    <Stack direction="column">
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ឈ្មោះសហគ្រាស :
                        </Typography>
                        <Typography className="print-invoice-header-title-bold">
                          ហ្គោ គ្លូបប៊ល ស្គូល
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title">
                          អាសយដ្ឋាន៖
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          ភូមិថ្មី សង្កាត់ស្វាយដង្គំ
                        </Typography>
                      </Stack>
                      <Typography className="print-invoice-header-title">
                        ក្រុងសៀមរាប ខេត្តសៀមរាប
                      </Typography>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title">
                          Tel:
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          076 777 1168 | 085 705 555
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          VATTIN:
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          B116-901504283
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xs={4}>
                    <Stack direction="column">
                      <Typography className="print-invoice-header-center-title-kh">
                        វិក្កយបត្រ
                      </Typography>
                      <Typography className="print-invoice-header-center-title">
                        Invoice
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={4}>
                    <Stack direction="column">
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          N° :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {moment().format("YYYY") + nextINVNumber}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          Bill To :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {billToVal?.title}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          Payment Date :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {moment(paymentDate).format("DD-MMM-YYYY hh:mm a")}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ marginTop: "15px" }}>
                <Typography className="print-invoice-header-title-bold">
                  ព័ត៌មានសិ្ស/Student Information
                </Typography>
                <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
                <Grid container>
                  <Grid item xs={6}>
                    <Stack direction="column" sx={{ marginTop: "4px" }}>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ឈ្មោះជាភាសាខ្មែរ/Full Name :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {detailsData?.lastName + " " + detailsData?.firstName}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          អត្តលេខ/Khmer ID :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {detailsData?.student_id}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ភេទ :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {detailsData?.gender}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          កម្រិត/Levels :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {classVal?.title}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack direction="column" sx={{ marginTop: "4px" }}>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ឈ្មោះឡាតាំង/Latin :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {detailsData?.englishName}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ថ្ងៃខែឆ្នាំកំណើត/Date of Birth :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {moment(detailsData?.dob).format("DD-MMM-YYYY")}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ពេលសិក្សា/Shift Time :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          Fake
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          លេខទូរស័ព្ទ/Tel :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {detailsData?.mother?.tel +
                            " | " +
                            detailsData?.father?.tel}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ marginTop: "15px" }}>
                <Typography className="print-invoice-header-title-bold">
                  ការបង់ថ្លៃ/Payment
                </Typography>
                <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
              </Box>
            </Box>

            <table className="print-invoice-table">
              <tr>
                <th style={{ width: "5%" }} align="left">
                  ល.រ
                </th>
                <th style={{ width: "20%" }} align="left">
                  បង់ថ្លៃ/Pay To
                </th>
                <th style={{ width: "20%" }} align="left">
                  បរិយាយ/Desciption
                </th>
                <th style={{ width: "15%" }} align="left">
                  ចាប់ទី/Start Date
                </th>
                <th style={{ width: "15%" }} align="left">
                  រហូតដល់/End Date
                </th>
                <th style={{ width: "25%" }} align="right">
                  សរុប/Total Amount
                </th>
              </tr>
              {paymentList?.map((row, index) => {
                // console.log("row::", row)
                return (
                  <tr key={index}>
                    <td align="left">{index + 1}</td>
                    <td align="left">
                      {row?.description ? row?.feeName : "តម្លៃសិក្សា"}
                    </td>
                    {row?.qty < 12 ? (
                      <td align="left">
                        {row?.qty} {row?.qty === 1 ? "month" : "months"}
                      </td>
                    ) : (
                      <td align="left">{row?.qty} year</td>
                    )}
                    <td align="left">
                      {moment(row?.startDate).format("DD-MM-YYYY")}
                    </td>
                    <td align="left">
                      {moment(row?.endDate).format("DD-MM-YYYY")}
                    </td>
                    <td align="right">
                      {currencyFormat(parseFloat(row?.totalAmount))}
                    </td>
                  </tr>
                );
              })}
            </table>
            <Box>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ padding: "4px" }}
              >
                <Typography className="print-invoice-header-title-bold">
                  សរុប (ដុល្លារ)/Total Amount ($) :
                </Typography>
                <Typography className="print-invoice-header-title">
                  $ {currencyFormat(parseFloat(totalUSD))}
                </Typography>
              </Stack>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
            <Box>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ padding: "4px" }}
              >
                <Typography className="print-invoice-header-title-bold">
                  សរុប (រៀល)/Total Amount (Riels) :
                </Typography>
                <Typography className="print-invoice-header-title">
                  {currencyFormatRiel(parseFloat(totalKHR))} ៛
                </Typography>
              </Stack>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
            <Box>
              <Stack direction="row" spacing={0.4} sx={{ padding: "4px" }}>
                <Typography className="print-invoice-header-title-bold">
                  ចំនួនទឹកប្រាក់ជាអក្សរ (ដុល្លារ)/Amount In Letter ($) :
                </Typography>
                <Typography className="print-invoice-header-title">
                  {toWords.convert(totalUSD ? parseFloat(totalUSD) : 0)} Dollar
                  Only
                </Typography>
              </Stack>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
            <Box sx={{ marginTop: "50px" }}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <Box className="print-invoice-box-bottom">
                    <Typography
                      className="print-invoice-footer-kh"
                      sx={{ textAlign: "center" }}
                    >
                      ប្រាក់បង់រូចមិនអាចដក ផ្ទេរ និងរក្សាទុកបានទេ
                    </Typography>
                    <Typography
                      className="print-invoice-footer-en"
                      sx={{ textAlign: "center" }}
                    >
                      All processed payments will not be refunded, transfered,
                      or kept.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Stack
                    direction="column"
                    spacing={0.2}
                    sx={{ marginTop: "18px" }}
                  >
                    <Divider sx={{ borderBottom: "1px solid #000" }} />
                    <Stack direction="row" spacing={0.2}>
                      <Typography className="print-invoice-footer-kh">
                        អ្នកបង់ប្រាក់
                      </Typography>
                      <Typography className="print-invoice-footer-en">
                        (Payer)
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack
                    direction="column"
                    spacing={0.2}
                    sx={{ marginTop: "18px" }}
                  >
                    <Divider sx={{ borderBottom: "1px solid #000" }} />
                    <Stack direction="row" spacing={0.2}>
                      <Typography className="print-invoice-footer-kh">
                        បេឡាធិការ
                      </Typography>
                      <Typography className="print-invoice-footer-en">
                        (Cashier)
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <Stack direction="row" justifyContent="right">
          <ReactToPrint
            content={reactToPrintContent}
            documentTitle={`${
              detailsData?.lastName + " " + detailsData?.firstName
            }-invoice`}
            removeAfterPrint
            trigger={reactToPrintTrigger}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
